export default __webpack_public_path__ + "static/media/34-min.f85c5167.png";